import React, { useRef, useState, useEffect } from "react";
import { message } from "antd";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef, ISelectOption } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText } from "@/utils/utils";
import { useWarehouseModel } from "../../warehouseModel";
import { IVRMShelfFormFields } from "../../warehouseTypes";
import { debounce } from "lodash";

//货位
export function ShelfDrawer() {
    const { shelfDrawer: { visible, mode }, setIShelfDrawer, selectedShelfRows, editFormVal,
        insertWarehouseShelf, batchInserttWarehouseShelf, updateWarehouseShelf, } = useWarehouseModel();
    const formRef = useRef<IYhFormRef>();
    const [isBatch, setIsBatch] = useState<boolean>(false);

    //监听批量录入字段
    const onChange = (changedValues: { [key: string]: any }) => {
        if ('isBatch' in changedValues) {
            setIsBatch(changedValues['isBatch']);
        }
    }
    const onCancel = () => {
        setIShelfDrawer();
        setIsBatch(false);
    }
    useEffect(() => {
        if (visible && mode === "edit") {
            setIsBatch(false); 
        };
        if (visible && mode === "add") { setIsBatch(false);  };
    }, [visible]);
    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            formRef.current?.inst().submit();
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const onFinish = (val: IVRMShelfFormFields) => {
        if (mode === "edit") {
            updateWarehouseShelf(val)
        } else {
            isBatch ? batchInserttWarehouseShelf(val) : insertWarehouseShelf(val);
        }
    }


    const [shelvesOptions, setShelvesOptions] = useState<ISelectOption[]>([]);

    const formConfig: IYhForm = {
        formRef,
        onFinish,
        formValues: mode === "edit" ? selectedShelfRows[0] : { warehouseName: editFormVal.name },
        labelCol: { span: 6 },
        onChange,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "所属仓库",
                fieldName: "warehouseName",
                span: 24,
                disable: true
            },  {
                type: FormItemTypeEnum.Input,
                fieldLabel: "货位编码",
                fieldName: "code",
                span: 24,
                disable: isBatch,
                rules: [{ required: !isBatch, message: "请输入货位编码" }]
            }, 
        ]
    };
    return (
        <YHDrawer
            {...{
                title: `货位${mode === "edit" ? "编辑" : "新增"}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: debounce(() => { onSubmit() }, 900)
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
